import { colors } from "@/design-system/theme/colors";

function SectionHeader({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <div className="mb-3">
      <h3 className="text-sm font-semibold" style={{ color: colors.textInverse }}>
        {title}
      </h3>
      {description && (
        <p className="text-xs mt-0.5" style={{ color: colors.textMuted }}>
          {description}
        </p>
      )}
    </div>
  );
}

export default SectionHeader;

